import React, { useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';

import Purchase from '../common/Purchase';
import BasicLayout from '../common/BasicLayout';
import { useCustomStripe } from '../common/Providers/CustomStripeProvider/UseCustomStripe';
import CheckoutForm from './CheckoutForm';
import { useResponsiveValues } from '../common/Providers/DimentionsProvider/UseResponsiveValues';
import { useStoreDetails } from '../common/Providers/StoreDetailsProvider/UseStoreDetails';
import { formatDateString } from '../common/Utils';
import { useCustomerReservation } from '../common/Providers/CustomerReservationProvider/UseCustomerReservation';
import { createReservationPre } from '../api/Product';

const CompletePurchase: React.FC = () => {
  
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { amount, clientSecret, stripePromise } = useCustomStripe();
  const { matches900 } = useResponsiveValues();
  const { storeDetails } = useStoreDetails();
  const { ReservationItems, ReservationMain, initReservation } = useCustomerReservation();
  const hasReserved = useRef(false);

  useEffect(()=>{
    if(!amount || !clientSecret){
      navigate('/');
    }
  }, []);

  useEffect(()=>{
    const accessToken = localStorage.getItem('access-token');
    if(!accessToken) navigate('/');

    if(ReservationMain.pickup && !hasReserved.current){
      const forSavingOnDB = {
        brand_id : storeDetails.brand_id,
        start_date : formatDateString(ReservationMain.pickup),
        end_date : ReservationMain.dropoff? formatDateString(ReservationMain.dropoff): '',
        subtotal : ReservationMain.prices.subtotal,
        tax_rate : storeDetails.sales_tax,
        tax_amount : ReservationMain.prices.tax,
        discount_amount : ReservationMain.prices.discount,
        total_price: ReservationMain.prices.total,
        price_table_id: ReservationMain.price_table_id,
        stage : 2,
        address_id : ReservationMain.address_id,
        use_manual : ReservationMain.use_manual,
        manual_address : ReservationMain.manual_address,
        email : ReservationMain.email,
        phone_number : ReservationMain.phone_number,
        driver_tip: ReservationMain.driver_tip,
        customer_id : localStorage.getItem('customerId'),
        items : ReservationItems,
        discount_code: ReservationMain.discount_code,
        promo_code: ReservationMain.promo_code,
        note: ReservationMain.note,
        stripe_cus_id: clientSecret.customer,
        preId: localStorage.getItem('preId') || null
      };
  
      createReservationPre(forSavingOnDB, (jsonRes:any, status)=>{
        console.log(jsonRes);
        console.log(status);
        const preId = jsonRes.reservation.id;
        localStorage.setItem('preId', preId);
      });
      hasReserved.current = true;
    }

  }, []);

  const appearanceOptions = {
    rules: {
      ".Input":{
        borderColor: "#cccccc"
      }
    },
    layout: {
      type: 'accordion',
      defaultCollapsed: true,
    }
  }

  const options = {
    clientSecret: clientSecret?.client_secret??'',
    appearance: appearanceOptions,
  };

  const renderCompletePurchase = () => (
    <BasicLayout>
      <Box sx={styles(matches900).container}>
        {amount > 0 && clientSecret &&(
          <Elements stripe={stripePromise} options={options}>
            <Box 
              sx={{ 
                display: 'flex',
                flex:1, 
                padding:'50px', 
                paddingTop: '50px', 
                borderLeft:'1px solid #ccc',
                justifyContent:'center',
              }}>
              <Box sx={{width:'100%', maxWidth:'900px'}}>
                <CheckoutForm/>
              </Box>
            </Box>
          </Elements>
        )}
        <Purchase 
          title='Reservation Details' 
          buttonTitle="Complete Purchase"
          isDisableDriverTip={true}
          isDisableDiscount={true}
          // CancelOrder={()=>{
          //   navigate('/reservation');
          //   initReservation();
          //   enqueueSnackbar("Order Canceled", {
          //     variant: 'success',
          //     style: { width: '350px' },
          //     autoHideDuration: 3000,
          //     anchorOrigin: { vertical: 'top', horizontal: 'right' },
          //   })
          //   if(hasReserved.current == true){
              
          //   }
          // }}
        />
      </Box>
    </BasicLayout>
  );

  return renderCompletePurchase();
}

const styles = (matches900:boolean) => ({
  container: {
    display:'flex', 
    flexDirection: matches900? 'row': 'column',
  },
  ReservationMainDetail: {
    flex:1, 
    p:matches900?'60px 40px':'30px 24px',
    overflow: 'auto',
  },
});

export default CompletePurchase;
